export default {
  noData: {
    summary: 'Nie znaleziono danych',
  },
  noAccess: 'Użytkownik nie ma dostępu',
};
